import { createFileRoute, notFound } from "@tanstack/react-router";
import type { JSX } from "react";

import { ManualReviewPage } from "@/features/manual-review";
import { isFeatureEnabled } from "@/shared/lib/feature-flags";

function ManualReviewRoute(): JSX.Element {
  return <ManualReviewPage />;
}

export const Route = createFileRoute("/_authenticated/manual-review")({
  beforeLoad: () => {
    // Behind PUBLIC_FEATURE_MANUAL_REVIEW until ops approval; the sidebar
    // entry is hidden by the same flag, this guards direct navigation.
    if (!isFeatureEnabled("manual_review")) throw notFound();
  },
  component: ManualReviewRoute,
});
